// @ts-nocheck
import React, { FC, createRef, forwardRef, useMemo } from "react";
import "../../../assets/css/colors.css";
import "../../../assets/css/size.css";
import "../../../assets/css/string.css";
import { GridHeaderColumnsType, TableComponentProps } from "../../interface";
import SlickGrid1 from "../SlickGrid1";

const TableComponent: FC<TableComponentProps> = forwardRef(
  ({ headerColumns, dataSource, query, remoteDataSource, ...rest }: TableComponentProps, ref) => {
    /*******************
@Purpose : table Component
@Parameter : TableComponentProps
@Author : Techture
 *******************/

    const gridRef = ref || createRef();

    // Convert Syncfusion-style headerColumns to SlickGrid1 columnDefinitions
    const columnDefinitions = useMemo(() => {
      if (!headerColumns) return [];
      return headerColumns.map((col: GridHeaderColumnsType, index: number) => ({
        id: col.field || `col_${index}`,
        field: col.field || "",
        name: col.headerText || "",
        clipMode: col.clipMode || "EllipsisWithTooltip",
        formatter: col.template,
        disableFiltering: col.allowFiltering === false,
        disableSorting: col.allowSorting === false,
      }));
    }, [headerColumns]);

    return (
      <SlickGrid1
        {...rest}
        ref={gridRef}
        gridOptions={{ forceFitColumns: true }}
        dataset={dataSource}
        remoteDataSource={remoteDataSource}
        query={query}
        columnDefinitions={columnDefinitions}
        infiniteScroll
      />
    );
  },
);

TableComponent.defaultProps = {};
TableComponent.displayName = "TableComponent";
export default TableComponent;
